<header class="root-container">
  <i (click)="showSidebar.emit()" class="bi bi-list sidebar-toggle"></i>
  <img 
  class="banner" 
  src="assets/images/common/company_logo.png" 
  [routerLink]="[auth.getRoleIndex()]"
  alt="Company logo"
  >
  <div style="flex:1;"></div>
  <header-notifications />
  <header-user-section />
</header>